import styled from 'styled-components';

export const Content = styled.div`
  position: relative;
`;

export const Button = styled.button`
  border: none;
  background: none;
  padding: 0;
  display: flex;
  align-items: center;
  gap: var(--s1);
  cursor: pointer;

  &.mobile-theme {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background: #f0f0f0;
    border: none;
    border-radius: 29px;
    gap: 0;

    svg {
      width: 14px;
      height: 14px;
    }
  }
`;

/* The elevated panel from the design system — one surface, one hairline, one
   shadow. Used by the topbar's two popovers and by all twelve filter popups. */
export const ContentShow = styled.div`
  position: absolute;
  width: 180px;
  right: 0;
  top: 0;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-md);
  box-shadow: var(--sh-2);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s;
  overflow: hidden;
  font-family: var(--font-ui);
  font-size: var(--fs-body);
  font-weight: var(--fw-regular);
  line-height: var(--lh-body);
  color: var(--text);
  padding: var(--s3) var(--s4);
  z-index: 10;

  &.show {
    opacity: 1;
    visibility: visible;
    top: 120%;
  }
`;

export const Items = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;
export const Item = styled.li`
  padding: 5px 0;
  user-select: none;
`;

export const ButtonText = styled.span`
  &.active {
    color: var(--primary-green);
  }
`;
